import {Button, GrayButton} from '@/components/common-components/v2';
import {useStore} from '@/store/root-store';
import {LoadingOutlined} from '@ant-design/icons';
import {Divider, Spin} from 'antd';
import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import {MissingPlacementsBanner} from './MissingPlacementsBanner';
import {TermsList} from './TermsList';
import {TermsSelectionDropdown} from './TermsSelectionDropdown';
import {convertHtmlToEditorState} from '@/utils/htmlToDraft';
// import {NextImg} from '@/utils/nextImg';


export const TermsAssistantRightSidebar = observer(() => {
  const {
    contentOptimizer: {
      currentPage: {
        setIsTaActive,
        setFocusTermsForInsertion,
        editContent,
        stagingTaSuggestions,
        setIsTaUpdating,
        updatingTa,
        clearAllTaData,
        setCurrentEditorState,
      },
    }} = useStore('');

  const antIcon = <LoadingOutlined style={{fontSize: 20, marginLeft: 10}} spin />;

  const onCancelClickHandler = () => {
    setIsTaActive(false);
    clearAllTaData();
    setFocusTermsForInsertion([]);
  };

  const onSubmitHandler = async () => {
    setIsTaUpdating(true);
    let finalHtmlOutput = '';

    for (let i = 0; i < stagingTaSuggestions?.length; i++) {
      if (!stagingTaSuggestions[i].isSuggestion) {
        finalHtmlOutput = finalHtmlOutput.concat(stagingTaSuggestions[i].html.replace('</p>', '<br /></p>'));
      }

      if (stagingTaSuggestions[i].isSuggestion) {
        if (stagingTaSuggestions[i].status == 'accepted') {
          finalHtmlOutput = finalHtmlOutput.concat(stagingTaSuggestions[i].suggestion);
        } else {
          finalHtmlOutput = finalHtmlOutput.concat(stagingTaSuggestions[i].html.replace('</p>', '<br /></p>'));
        }
      }
    }

    if (finalHtmlOutput.startsWith('<NextImg')) finalHtmlOutput = '<p>&nbsp;</p>' + finalHtmlOutput;
    const updatedEditorState = convertHtmlToEditorState(finalHtmlOutput);
    try {
      await editContent(updatedEditorState, finalHtmlOutput);
      // const newState = currentPage?.content?.formattedEditorState();
      setCurrentEditorState(updatedEditorState);

      setIsTaActive(false);
      clearAllTaData();
    } catch (e) {
      return Promise.reject(e);
    } finally {
      setIsTaUpdating(false);
    }
  };

  return <TaWrapper>
    <Divider style={{backgroundColor: '#4E5156', marginTop: 0, marginBottom: 12}}/>
    <TermsMainWrapper>
      <TitleContainer>
        <Title>Terms Assistant</Title>
        <TermsSelectionDropdown />
      </TitleContainer>
      <Description>
      Go through the suggestions for inserting terms to see how they look like in your article. Accept or dismiss individual ones.
        <br />
        <br />
      * Save changes to update your article.
      </Description>
      <MissingPlacementsBanner />
      <TermsList />
    </TermsMainWrapper>
    <ActionButtonsContainer>
      <Button
        disabled={updatingTa || !stagingTaSuggestions?.some(item => item.status !== 'default')}
        color='green'
        style={{marginBottom: 10, width: '-webkit-fill-available', justifyContent: 'center', display: 'flex'}}
        onClick={() => onSubmitHandler()}>
        {updatingTa ? 'Updating Article...' : 'Save & Update Article'}
        {updatingTa ? <Spin indicator={antIcon} /> : null}
      </Button>
      <GrayButton
        disabled={updatingTa}
        color='gray'
        variant='noBorder'
        style={{width: '-webkit-fill-available'}}
        onClick={() => onCancelClickHandler()}>
      Cancel
      </GrayButton>

    </ActionButtonsContainer>
  </TaWrapper>;
});

const TaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  padding-bottom: 20px;
`;
const TermsMainWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 5px;

  // For Internet Explorer
  scrollbar-face-color: rgba(138,138,138,0.32);
  scrollbar-track-color: rgba(138,138,138,0.12);

  // For Google Chrome
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #E8E8E8;
  }

  &::-webkit-scrollbar-track {
    background: rgba(138,138,138,0.12);
  }
`;
const ActionButtonsContainer = styled.div`
  background-color: #24262a;
  width: 100%;
`;
const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Title = styled.div`
  font-weight: 500;
  font-size: 16px;
  color: #fff;
`;
const Description = styled.div`
  font-size: 12px;
  color: #e8e8e8;
  line-height: 15px;
  margin-bottom: 20px;
`;
